<template lang="pug">
  .ticket-info
    .figuras
      .caja
        .rectangulo
          div
            .ticket-number(v-if="number") {{number}}
              slot(name="number")
          div
            .ticket-title(:class="getClassForShowText(title)") {{title}}
              slot(name="title")
            .ticket-subtitle(:class="getClassForShowText(subtitle)") {{subtitle}}
              slot(name="subtitle")
            .ticket-link(:class="getClassForShowText(link.text)" v-if="hasLink()")
              router-link(:to="link.to" v-if="link" @click.native="$event.stopImmediatePropagation()") {{link.text}}
              slot(name="link")
        .circulo-container(:class="`${iconInvertColor ? 'invert-color':''}`" v-if="icon")
          .circulo.center
            .icon(:class="icon")
            slot(name="icon")
        .linea(:class="`${iconInvertColor ? 'invert-color':''}`" v-if="hasValues()")
    .textos
      .texto(v-if="hasValues()")
        div(v-for="item in values" v-if="values" v-html="item")
        slot(name="values")
</template>

<script>
import { hasValue } from '@/utils/object.js'

export default {
  props: {
    number: {
      type: [String, Number],
      default: ''
    },
    title: String,
    subtitle: String,
    icon: String,
    iconInvertColor: Boolean,
    values: {
      type: Array,
      default: () => null
    },
    link: {
      type: Object,
      default: () => null
    }
  },
  methods: {
    hasValues () {
      return (this.values && this.values.length) || (this.$slots.values && this.$slots.values.length)
    },
    hasLink () {
      return (this.link && hasValue(this.link)) || (this.$slots.link && this.$slots.link.length)
    },
    getClassForShowText (val) {
      if (!val) return ''
      return val.toString().length > 60 ? 'lgt-60' : ''
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

$line-width = $f7px
$caja-height = $f36px
$circulo = $f38px
$semicirculo = ($circulo / 2)

.ticket-info
  display: flex
  font-size: $f16px
  line-height: 1
  @media screen and (min-width: 1603px)
    font-size: $f14px

.figuras
  min-height: $f68px
  display: flex
  align-items: center
  flex: 1 1 60%

.caja
  height: $caja-height
  position: relative
  min-width: $f132px
  width: 100%
  color: white
  display: flex
  align-items: center
  justify-content: space-between

.rectangulo
  height: 100%
  width: "calc(100% - %s)" % ($semicirculo + $line-width)
  background-color: $color_0
  box-sizing: border-box
  display: flex
  align-items: center
  padding: 0 $semicirculo 0 $f5px

@media screen and (max-width: 500px)
  .ticket-number
    font-size: 4vw !important;
  .ticket-title
    font-size: 3vw !important;

.ticket-number
  font-size: $f34px
  font-weight: bold
  padding-right: $f4px
.ticket-title
  font-size: $f14px
  font-weight: bold
  &.lgt-60
    font-size: $f10px
.ticket-subtitle
  font-size: $f10px
  &.lgt-60
    font-size: $f10px
.ticket-link
  &.lgt-60
    font-size: $f11px

.circulo-container
  border-radius: 50%
  border: $f3px solid white
  height: $circulo
  position: absolute
  width: $circulo
  top: - $f4px
  right: $line-width
  &.invert-color
    border-color: $color_0

.circulo
  width: 100%
  height: 100%
  background-color: $color_0
  border-radius: 50%
  .invert-color &
    background-color: white

.icon
  font-size: $f25px
  z-index: 2
  .invert-color &
    color: $color_0

.textos
  display: flex
  align-items: center
  flex: 1 1 40%

.linea
  height: $f2px
  width: $circulo
  z-index: 1
  background-color: $color_0
  &.invert-color
    z-index: -1

.texto
  border-left: $f2px solid $color_0
  min-height: $caja-height
  padding-left: $f10px
  display: flex
  flex-direction: column
  justify-content: center
  align-content: space-between
  width: 100%

</style>
